import { Button, Stack } from '@servicetitan/design-system';
import { FC } from 'react';
import { EmptyResultsPlaceholder, EmptyResultsPlaceholderProps } from './empty-results-placeholder';

interface EmptyResultsFiltersPlaceholderProps extends EmptyResultsPlaceholderProps {
    showFilterButtons?: boolean;
    onEditFiltersClick?: () => void;
    onClearFiltersClick?: () => void;
}

export const EmptyResultsFiltersPlaceholder: FC<EmptyResultsFiltersPlaceholderProps> = ({
    onClearFiltersClick,
    onEditFiltersClick,
    showFilterButtons,
    ...otherProps
}) => (
    <EmptyResultsPlaceholder {...otherProps}>
        {showFilterButtons && (
            <Stack spacing={2} className="m-t-2">
                {!!onEditFiltersClick && (
                    <Button outline onClick={onEditFiltersClick}>
                        Edit filters
                    </Button>
                )}
                <Button outline onClick={onClearFiltersClick}>
                    Clear filters
                </Button>
            </Stack>
        )}
    </EmptyResultsPlaceholder>
);
